import React, { Component, Fragment } from "react";
import ReactImageVideoLightbox from "react-image-video-lightbox";
const playIcon = require("../../images/YtPlayIcon.svg");

class LightboxImages extends Component {
  constructor(props) {
    super(props);
  }
  handleClose = (e) => {
    if (
      e.type == "click" &&
      e.target.parentNode.classList.contains("lightBoxModal")
    ) {
      this.props.onClose();
      window.removeEventListener("click", this.handleClose);
    } else if (e.type == "keydown" && e.key === "Escape") {
      this.props.onClose();
      document.removeEventListener("keydown", this.handleClose);
    }
  };

  render() {
    const {
      images,
      thumbnails,
      onClickThumbnail,
      visible,
      currentImage,
      onClose,
    } = this.props;

    let items = [];
    if (images && images.length > 0) {
      items = images.map((item) => {
        return {
          url: item.src,
          type: item.iframe ? "video" : "photo",
        };
      });
    }

    return !images || images.length < 1 ? (
      <Fragment />
    ) : (
      <Fragment>
        <div className="small-12 large-12 columns product-detail__big-image">
          <div>
            <div className="row product-detail__small-images-container">
              {images.map(
                (image, index) =>
                  index > 0 && (
                    <div className="product-detail__small-images" key={index}>
                      <a
                        data-src={image.src}
                        itemProp="url"
                        onClick={() => {
                          onClickThumbnail(index);
                          window.addEventListener("click", this.handleClose);
                          document.addEventListener("keydown", this.handleClose);
                        }}
                        className="product-image"
                      >
                        <img
                          className="product-detail__image--alter product-detail__thumbnail"
                          itemProp="image"
                          src={thumbnails[index].src}
                        />
                        {items[index].type === "video" && (
                          <span
                            className="product-detail__playicon"
                            alt="Play Icon"
                          />
                        )}
                      </a>
                    </div>
                  )
              )}
            </div>
          </div>
          <figure className="product-detail__image-container">
            <a
              data-src={images[0].src}
              itemProp="url"
              onClick={() => {
                onClickThumbnail(0);
                window.addEventListener("click", this.handleClose);
                document.addEventListener("keydown", this.handleClose);
              }}
              className="product-image"
            >
              <img
                className="product-detail__image--main"
                itemProp="image"
                src={thumbnails[0].src}
              />
            </a>
          </figure>
        </div>

        <div className="lightBoxModal">
          {visible && (
            <ReactImageVideoLightbox
              data={items}
              startIndex={currentImage}
              showResourceCount={true}
              onCloseCallback={() => onClose()}
              onNavigationCallback={(currentIndex) =>
                console.log(`Current index: ${currentIndex}`)
              }
            />
          )}
        </div>
      </Fragment>
    );
  }
}

export default LightboxImages;
